import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Cart from '../services/cart';


const UnifiedPayment = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [paymentStatus, setPaymentStatus] = useState('');
    const orderNumber = location.state?.orderNumber;
    const paymentLink = location.state?.paymentLink;

    useEffect(() => {
        if (!paymentLink) {
            toast.error("Invalid payment link");
            navigate(-2);
            return;
        }

        const handleMessage = (event) => {
            if (event.origin !== 'https://mobstep.com') {
                return; // Ensure the message is from the correct origin
            }
            if (event.data === 'payment-success') {
                setPaymentStatus('success');
                Cart.clearCart();
                toast.success("Payment successful!");
                navigate('/checkout/confirmation', { state: { orderNumber: orderNumber } });
            } else if (event.data === 'payment-failure') {
                setPaymentStatus('failure');
                toast.error("Payment failed!");
                navigate(-2);  // Go back to the previous page
            }
            
        };


        

        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [navigate, paymentLink, orderNumber]);

    return (
        <div className="unified-payment-container">
            {paymentLink && (
                <iframe
                    src={paymentLink}
                    title="Unified Payment"
                    style={{ width: '100%', height: '90vh', border: 'none' }}
                    sandbox='allow-same-origin allow-scripts allow-forms allow-popups'                    
                />
            )}

            {paymentStatus === 'failure' && (
                <div className="payment-failure">
                    <p>Payment failed. Please try again.</p>
                </div>
            )}
            <ToastContainer />
        </div>
    );
};

export default UnifiedPayment; 